import { render, staticRenderFns } from "./BasePageSpinner.vue?vue&type=template&id=46651073&"
import script from "./BasePageSpinner.vue?vue&type=script&lang=js&"
export * from "./BasePageSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports